import React from 'react';
import { FA6 } from './iconList';

const SingleIcon = ({ iconComponentName, size = 48, color = 'black' }) => {
  const IconComponent = FA6[iconComponentName];
  if (!IconComponent) return <p>Icon not found</p>; // Handle invalid icon names

  return <IconComponent size={size} color={color} />;
};

export default SingleIcon;
